import React from 'react';
import PropTypes from 'prop-types';
import css from './Calendar.css';
import 'global/react-dates-overrides.scss';
import {DayPickerRangeController} from 'react-dates';

export default class Calendar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      startDate: props.startDate,
      endDate: props.endDate,
      focusedInput: 'startDate'
    }

  }

  onFocusChange(focusedInput) {
    // Force the focusedInput to always be truthy so that dates are always selectable
    this.setState({focusedInput: !focusedInput ? 'startDate' : focusedInput});

  }

  render() {
    return (
      <div className={css["container"]} aria-hidden={true}>

          <DayPickerRangeController
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            onDatesChange={this.props.onCalendarDateChange}
            focusedInput={this.state.focusedInput}
            onFocusChange={this.onFocusChange.bind(this)}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            transitionDuration={0}
            noBorder
            isOutsideRange={this.props.isOutsideRange}
          />
        </div>
    );
  }
}

Calendar.propTypes = {
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object,
  onCalendarDateChange: PropTypes.func.isRequired,
  isOutsideRange: PropTypes.func.isRequired,
  isStartDate: PropTypes.string
};




